import SchoolSchedule from "../views/schooladmin/SchoolSchedule";

export default [
	{
		path: "/schooladmin/school_schedule",
		components: {
			content: SchoolSchedule
		}
	}
];
